
// This is an auto generated file - do not edit!
// Swagger path: /api/ActivityFile/export

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Export
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ActivityfileExportApiService extends BaseApiService {
    
    post(_export: any, options = {}): Observable<Export> {
        return this._post<Export, any>(
            `/ActivityFile/export`,
            _export,
            options
        );
    }
}
